export default __webpack_public_path__ + "static/media/chat-icon.6cdd05a8.svg";